<div class="tail-flex-col tail-p-8 tail-border-2">
  <ng-container *ngIf="channel">
    <div >{{channel.friendlyName}}</div>
    <div><span><b>{{lastMessage}}</b></span></div>
  </ng-container>
</div>
